/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-12 11:07:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-18 15:13:21
 * @FilePath: /src/app/(staitc-page)/student-discount/components/MightLike.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';
import { fetchProductList } from '@/api/product';
import { ListProduct } from '@/api/types/public';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { formatPriceNumberWithSymbol, genPrice } from '@/utils/price';
import { setSession } from '@/utils/tools';
import { useMediaQuery } from '@mui/material';
import { LeftArrowOutlined, RightArrowOutlined } from '@zeelool/icon';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './MightLike.css';

export default function MightLike() {
  const swiperRef = useRef<any>(null);
  const [list, setList] = useState<ListProduct[]>([]);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const currency = useStore((state) => state.currency);
  const userInfo = useStore((state) => state.userInfo);
  const isMobile = useMediaQuery('(max-width:700px)');

  const swiperOptions = {
    modules: [Navigation, Autoplay, Pagination],
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    onSlideChange: (swiper: any) => {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);
    },
    onInit: (swiper: any) => {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const res = await fetchProductList({
        limit: 8,
        currency: currency.name,
        group_id: 116,
      });

      setList((res as any).data.list);
    } catch (error) {
      logger.error('获取数据失败:', error);
    }
  };

  const priceInfo = (item: ListProduct) => {
    if (
      userInfo.is_member === 1 &&
      item[`price_info_v${userInfo.member_level}`] &&
      item[`discount_percent_v${userInfo.member_level}`] > 0
    ) {
      return genPrice(item[`price_info_v${userInfo.member_level}`], currency.name);
    }
    if (item.price_info) {
      return genPrice(item.price_info, currency.name);
    }
    return { price: 0, sell_price: 0 };
  };

  return (
    <>
      <div className="my-[15px] md:my-[70px] mx-[14px]">
        {list.length > 0 && !isMobile && (
          <>
            <h3 className="mb-[30px] text-[30px] font-bb flex items-center text-center">
              <div className="flex-1 h-px bg-gray-300 mr-[80px]" />
              <span>Recommend Products</span>
              <div className="flex-1 h-px bg-gray-300 ml-[80px]" />
            </h3>
            <div className="relative w-full max-w-[1740px] px-[50px] mx-auto box-border might-like-content">
              <Swiper ref={swiperRef} className="might-like-img" {...swiperOptions}>
                {list.map((item, index) => (
                  <SwiperSlide
                    key={index}
                    className="px-[30px] box-border text-center text-sm cursor-pointer"
                  >
                    <Link
                      href={`/goods-detail/${item.shop_sku}`}
                      onClick={() => {
                        setSession('zl_goodsDetailEnterPageScene', '学生折扣说明页推荐商品坑位');
                      }}
                      className="block text-gray-800 no-underline flex items-center justify-center flex-col"
                    >
                      <Image
                        src={item.image.product[0]}
                        alt=""
                        className="max-w-full"
                        width={200}
                        height={200}
                      />
                      <p className="py-[9px] px-0 m-0">{item.short_name}</p>
                      <p className="m-0 notranslate">
                        <span
                          className={`inline-block text-lg  ${
                            priceInfo(item).sell_price !== priceInfo(item).price ? 'sale' : ''
                          }`}
                        >
                          {formatPriceNumberWithSymbol(priceInfo(item).sell_price, currency)}
                        </span>
                        {priceInfo(item).sell_price !== priceInfo(item).price && (
                          <span className="ml-[15px] text-gray-800 text-base text-gray-800 line-through inline-block">
                            {formatPriceNumberWithSymbol(priceInfo(item).price, currency)}
                          </span>
                        )}
                      </p>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* 分页器 */}
              <div className="swiper-pagination w-full mt-[10px]" />

              {/* 导航按钮 */}
              <div
                className={`might-like-prev absolute top-[40%] left-[30px] z-10 cursor-pointer transition-opacity ${isBeginning ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => !isBeginning && swiperRef.current?.swiper?.slidePrev()}
              >
                <LeftArrowOutlined className="text-[26px] transform -translate-y-1/2 outline-none" />
              </div>
              <div
                className={`might-like-next absolute top-[40%] right-[30px] z-10 cursor-pointer transition-opacity ${isEnd ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => !isEnd && swiperRef.current?.swiper?.slideNext()}
              >
                <RightArrowOutlined className="text-[26px] transform -translate-y-1/2 outline-none" />
              </div>
            </div>
          </>
        )}

        {list.length > 0 && isMobile && (
          <>
            <h3 className="mb-[30px] text-[16px] font-bs text-left">
              <span>Recommend Products</span>
            </h3>
            <div>
              <ul className="grid grid-cols-2 gap-[34px]">
                {list.map((item, index) => (
                  <li key={index}>
                    <Link
                      href={`/goods-detail/${item.shop_sku}`}
                      onClick={() => {
                        setSession('zl_goodsDetailEnterPageScene', '学生折扣说明页推荐商品坑位');
                      }}
                      className="block  no-underline"
                    >
                      <Image
                        src={item.image.product[0]}
                        alt=""
                        className="max-w-full"
                        width={200}
                        height={200}
                      />
                      <p className="py-[9px] px-0 m-0 text-[14px] font-bb text-center">
                        {item.short_name}
                      </p>
                      <p className="m-0 notranslate text-center">
                        <span
                          className={`text-gray-800 text-base inline-block  ${
                            priceInfo(item).sell_price !== priceInfo(item).price ? 'sale' : ''
                          }`}
                        >
                          {formatPriceNumberWithSymbol(priceInfo(item).sell_price, currency)}
                        </span>
                        {priceInfo(item).sell_price !== priceInfo(item).price && (
                          <span className="ml-[15px] text-sm text-[#a9a9a9]  text-underline inline-block line-through ">
                            {formatPriceNumberWithSymbol(priceInfo(item).price, currency)}
                          </span>
                        )}
                      </p>
                    </Link>
                  </li>
                ))}
              </ul>
              <p className="nodata text-center text-[12px] text-[#282828] mt-[34px]">
                —— No More ——
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
}
